import type { SurveyPage } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { shouldIncludePageInPath } from '../visibility';

export function getPreviousVisiblePageIndex(
  pages: SurveyPage[],
  currentPageIndex: number,
  context: LogicContext
): number {
  let pageIndex = currentPageIndex - 1;

  while (pageIndex >= 0) {
    while (pageIndex >= 0 && (pages[pageIndex]?.questions ?? []).length === 0) {
      pageIndex -= 1;
    }

    if (pageIndex < 0) {
      return 0;
    }

    const questions = pages[pageIndex]?.questions ?? [];
    if (shouldIncludePageInPath(questions, context)) {
      return pageIndex;
    }

    pageIndex -= 1;
  }

  return 0;
}
